/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_SubInputs */

const en_mk_team_sub = /** @type {(inputs: Mk_Team_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose where coding runs and which AI it uses on the Build page. Bystep assigns work from the same plan and checks the combined results.`)
};

const id_mk_team_sub = /** @type {(inputs: Mk_Team_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari halaman Bangun, pilih tempat coding berjalan dan sumber AI-nya. Bystep membagi pekerjaan dari rencana yang sama, lalu memeriksa hasil gabungannya.`)
};

/**
* | output |
* | --- |
* | "Choose where coding runs and which AI it uses on the Build page. Bystep assigns work from the same plan and checks the combined results." |
*
* @param {Mk_Team_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_sub = /** @type {((inputs?: Mk_Team_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_sub(inputs)
	return en_mk_team_sub(inputs)
});